// src/components/Mechanism2.tsx
import React from 'react';
import '../App.scss';

const Mechanism2: React.FC = () => {
  return (
    <section className="mechanism-section">
      <div className="container-fluid">
        <div className="hero-banner">
          <div className="hero-wrapper">
            <h1 className="hero-kings-title">
              <span className="hero-kings-upoznaj">UPOZNAJ ULTRA</span>
              <span className="hero-kings-kraljeve">KRALJEVE</span>
            </h1>
            {/* Spacer: dugme uklonjeno (prijava je u navigaciji), prostor ostaje da se layout ne pomeri */}
            <div className="hero-cta" aria-hidden="true" />
          </div>
        </div>
      </div>

      <img
        src="/player-strahinja.png"
        alt="Strahinja Stojačić"
        className="hero-player hero-player-strahinja"
      />
      <img
        src="/player-bogi.png"
        alt="Bogdan Bogdanović"
        className="hero-player hero-player-bogi"
      />

      <div id="nagrade" className="hero-prizes">
        <div id="glavna-nagrada" className="prize-card prize-card--main">
          <span className="prize-label">GLAVNA NAGRADA</span>
          <div className="prize-box">
            <p className="prize-la">
              <span className="prize-la-line">
                <span className="prize-la-small">PUT</span>
                <span className="prize-la-small">U</span>
                <span className="prize-la-big">LOS</span>
              </span>
              <span className="prize-la-big prize-la-angeles">ANGELES</span>
            </p>
          </div>
        </div>

        <div className="prize-card prize-card--weekly">
          <span className="prize-label">SVAKE NEDELJE</span>
          <div className="prize-box">
            <div className="prize-item prize-item--iphone">
              <img
                src="/nagrada-iphone.png"
                alt="iPhone 17"
                className="prize-img prize-img--iphone"
              />
              <div className="prize-qty prize-qty--stack">
                <span className="prize-qty-num">&times;25</span>
                <span className="prize-qty-desc">iPhone 17</span>
                <span className="prize-qty-desc">256GB</span>
              </div>
            </div>

            <span className="prize-divider" />

            <div className="prize-vouchers">
              <img
                src="/nagrada-jumbo-sportvision.png"
                alt="Jumbo Travel i Sport Vision vaučeri"
                className="prize-img prize-img--vouchers"
              />
            </div>

            <div className="prize-item prize-item--split">
              <div className="prize-qty prize-qty--stack">
                <span className="prize-qty-num">&times;25</span>
                <span className="prize-qty-desc">
                  JUMBO
                  <br />
                  TRAVEL
                  <br />
                  vaučer
                </span>
              </div>
              <span className="prize-split" />
              <div className="prize-qty prize-qty--stack">
                <span className="prize-qty-num">&times;100</span>
                <span className="prize-qty-desc">
                  SPORT
                  <br />
                  VISION
                  <br />
                  vaučer
                </span>
              </div>
            </div>
          </div>
        </div>

        <div className="prize-card prize-card--daily">
          <span className="prize-label">DNEVNA NAGRADA</span>
          <div className="prize-box">
            <div className="prize-item prize-item--daily">
              <img
                src="/nagrada-limenke.png"
                alt="Ultra Fruit Punch paket"
                className="prize-img prize-img--cans"
              />
              <div className="prize-qty prize-qty--stack">
                <span className="prize-qty-num">&times;1855</span>
                <span className="prize-qty-desc">
                  ULTRA
                  <br />
                  FRUIT PUNCH
                  <br />
                  paket
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Mechanism2;
